export type Step = (typeof RESET_PASSWORD_FORM_STEPS)[number];

export const STEP_ACCOUNT = 'account';
export const STEP_VERIFY_PHONE = 'verify';
export const STEP_NEW_PASSWORD = 'new-password';

export const RESET_PASSWORD_FORM_STEPS = [STEP_ACCOUNT, STEP_VERIFY_PHONE, STEP_NEW_PASSWORD] as const;
